import Reveal from '../../../shared/Reveal/Reveal';
import { usePlatformsEntryPointsContent } from '../../../../hooks/usePlatformsEntryPointsContent';
import fingerprintIcon from '../../../../assets/images/platforms/entrypoints/Fingerprint.svg';
import './EntryPoints.css';

const EntryPoints = () => {
  const { content, isLoading } = usePlatformsEntryPointsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, icon } = content;

  return (
    <section className="platforms-entry-points">
      <div className="platforms-entry-points__inner">
        <Reveal className="platforms-entry-points__content">
          <img
            className="platforms-entry-points__icon"
            src={icon || fingerprintIcon}
            alt=""
            aria-hidden="true"
          />
          <h2 className="platforms-entry-points__title">{title}</h2>
          {text ? <p className="platforms-entry-points__text">{text}</p> : null}
        </Reveal>
      </div>
    </section>
  );
};

export default EntryPoints;
